module.exports = __webpack_public_path__ + "static/img/3.868a682.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/eng/3.png
// module id = Qrdg
// module chunks = 0